import { useSelector } from "react-redux";
import { IRepoV2ReduxState } from "repoV2/features/Common/modules/Reducer/Reducer.interface";

/**
 * This hook returns `{isPaymentProcessing}` which denotes payment is still being processed or not
 * @returns object
 * {
 *   isPaymentProcessing => boolean whether the initiate booking request is successful/failed
 *   for payment
 *   true until initiateBooking for Payment Api request is fullfilled/failed
 *   false otherwise.
 * }
 */
const useGetIsPaymentProcessing = () => {
    const isPaymentProcessing = useSelector(
        (state: IRepoV2ReduxState) => state.checkoutPages.isPaymentProcessing
    );
    return {
        isPaymentProcessing,
    };
};

export default useGetIsPaymentProcessing;
